var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-batch-grant',{staticClass:"pt-batch-grant__page",attrs:{"recordMessage":_vm.recordMessage}})}
var staticRenderFns = []

export { render, staticRenderFns }